import GlobalComponent from './GlobalComponent'
export default GlobalComponent
